import React from 'react';
import { useChatRoomTheme } from '../../contexts/ChatRoomThemeContext';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const ToggleButton = styled.button<{ $isDark: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.xs};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  background: ${props => props.$isDark 
    ? 'rgba(255, 255, 255, 0.1)' 
    : 'rgba(0, 0, 0, 0.05)'};
  border: 1px solid ${props => props.$isDark 
    ? 'rgba(255, 255, 255, 0.2)' 
    : 'rgba(0, 0, 0, 0.1)'};
  border-radius: ${theme.borderRadius.md};
  color: ${props => props.$isDark ? 'white' : '#333'};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 100px;

  &:hover {
    background: ${props => props.$isDark 
      ? 'rgba(255, 255, 255, 0.15)' 
      : 'rgba(0, 0, 0, 0.08)'};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.xs} ${theme.spacing.sm};
    font-size: 0.8rem;
    min-width: 80px;
  }
`;

const Icon = styled.span`
  font-size: 1rem;
  line-height: 1;
`;

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useChatRoomTheme();
  const isDark = theme === 'dark';

  return (
    <ToggleButton 
      $isDark={isDark} 
      onClick={toggleTheme}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`}
      title={`Switch to ${isDark ? 'light' : 'dark'} theme`}
    >
      <Icon>{isDark ? '🌙' : '☀️'}</Icon>
      <span>{isDark ? 'Dark' : 'Light'}</span>
    </ToggleButton>
  );
};

